import { Box, Typography } from '@mui/material';
import React from 'react';

const System = () => {
  return (
    <Box>
      <Typography variant="h4">System</Typography>
      <Typography variant="body1">Management System Page</Typography>
    </Box>
  );
};

export default System;
